import React, { FC, ReactNode, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { isNil } from 'lodash';
import { StyleProps } from '@styles';

interface Props extends StyleProps {
  onHeaderElementVisibilityChange: (element: Element, inView: boolean) => void;
  attributes?: Attributes;
  children: ReactNode;
  Tag: keyof JSX.IntrinsicElements;
}

interface Attributes {
  id?: string;
}

export const IntersectionObserverElement: FC<Props> = ({
  Tag,
  children,
  attributes,
  onHeaderElementVisibilityChange,
  style,
  className,
}) => {
  const [ref, inView, entry] = useInView({
    threshold: 0,
  });

  useEffect(() => {
    if (isNil(entry)) return;
    onHeaderElementVisibilityChange(entry.target, inView);
  }, [inView]);

  return React.createElement(Tag, attributes ? { ref, style, className, ...attributes } : { ref, style, className }, children);
};

export default IntersectionObserverElement;
